import styles from '../VehicleAllocationColumn.module.scss'
import { useDroppable } from '@dnd-kit/core'
import { AllocationBonnet } from './AllocationBonnet'
import { Allocation } from '@/types/vehicleAllocation'
import { useVehicleAllocationStore } from '@/pages/VehicleAllocationController'

interface VehicleAllocationItemProps {
    allocation: Allocation
    allAllocations: Allocation[]
    route: string
}

export const VehicleAllocationItem = ({ allocation, allAllocations, route }: VehicleAllocationItemProps) => {
    const { allocationChanges, routeEditing } = useVehicleAllocationStore()
    const allocationChange = allocationChanges.find((change) => change.run === allocation.run)

    const { setNodeRef: setDroppableNodeRef } = useDroppable({
        id: allocation.run,
        data: { bonnet: allocationChange?.fleetNumber ?? allocation.bonnet },
        disabled: routeEditing !== route,
    })

    return (
        <div ref={setDroppableNodeRef} className={styles.allocationItem}>
            <div className={styles.run}>{allocation.run}</div>

            <AllocationBonnet
                allocation={allocation}
                allAllocations={allAllocations}
                allocationChange={allocationChange}
                route={route}
            />
        </div>
    )
}
